(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["al-site-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const trigger=event.target.closest('[data-al-play]');if(trigger){const video=document.querySelector('#al-reflection video');if(video){video.play().catch(function(){});video.focus();}}});
function alPublish(name,data){const shop=window.Shopify;if(!shop?.customerPrivacy?.analyticsProcessingAllowed?.()||!shop.analytics?.publish)return;try{shop.analytics.publish('artlectio:'+name,data);}catch(error){}}
document.querySelectorAll('.al-reflection video').forEach(function(video){video.addEventListener('play',function(){alPublish('reflection_play',{artwork:'the-milkmaid',page:location.pathname});},{once:true});});
document.addEventListener('click',function(event){const link=event.target.closest('a[href]');if(link&&link.hostname==='artlectio.substack.com')alPublish('substack_click',{page:location.pathname});});
if(document.querySelector('#AdventInterest')){alPublish('advent_view',{page:location.pathname});if(document.querySelector('.al-interest-success'))alPublish('advent_signup_success',{page:location.pathname});}
  } catch(e) { console.error(e); }
})();

})();
